module.exports = __webpack_public_path__ + "img/support.5077d1ce.svg";